import React, { Dispatch, SetStateAction } from 'react';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import Checkbox from '@material-ui/core/Checkbox';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Box from '@material-ui/core/Box';
import { ExpandMore, ExpandLess } from '@material-ui/icons';
import colors from '../../themes/main-colors';
import { useTranslation } from '../../hooks/useTranslation';

export type CustomerMailingAddressProps = {
  sameAddressText: string | React.ReactNode;
  useAltMailingAddress: boolean;
  setUseAltMailingAddress?: Dispatch<SetStateAction<boolean>>;
  setUseAltMailingAddressForSSM?: () => void;
  id?: string;
};

const CustomerMailingAddress = ({
  sameAddressText,
  useAltMailingAddress,
  setUseAltMailingAddress,
  setUseAltMailingAddressForSSM,
  id,
}: CustomerMailingAddressProps) => {
  const { t } = useTranslation();

  return (
    <>
      <Grid container direction="column">
        <Grid item>
          <FormControlLabel
            id={id}
            data-testid="service-address-label"
            control={
              <Checkbox
                checked={!useAltMailingAddress}
                data-testid={'mailingAddressId'}
                onChange={() => {
                  if (setUseAltMailingAddressForSSM) {
                    setUseAltMailingAddressForSSM();
                  } else if (setUseAltMailingAddress) {
                    setUseAltMailingAddress(!useAltMailingAddress);
                  }
                }}
                color="primary"
              />
            }
            label={sameAddressText}
          />
        </Grid>
        <Grid item>
          <Typography
            variant="body1"
            onClick={(e: any) => {
              e.preventDefault();
              if (setUseAltMailingAddressForSSM) {
                setUseAltMailingAddressForSSM();
              } else if (setUseAltMailingAddress) {
                setUseAltMailingAddress(!useAltMailingAddress);
              }
            }}
            style={{ cursor: 'pointer' }}
            component="div"
          >
            <Box display="flex" alignItems="center">
              <span
                style={{
                  color: colors.sparkBlue,
                }}
              >
                {useAltMailingAddress
                  ? t('USE_SAME_ADDRESS')
                  : t('USE_DIFFERENT_ADDRESS')}
              </span>
              {useAltMailingAddress ? (
                <ExpandLess style={{ fontSize: 29 }} />
              ) : (
                <ExpandMore style={{ fontSize: 29 }} />
              )}
            </Box>
          </Typography>
        </Grid>
      </Grid>
    </>
  );
};

export default CustomerMailingAddress;
